const atmStoreModule = {
  namespaced:true,
  state: () => ({
    atmWebOrigin: '',//爱他美后管的地址
    accessToken: '',//请求凭证
    currentUser: {}, //当前登录用户信息
  }),
  getters: {
    atmWebOrigin (state) {
      return state.atmWebOrigin
    },
    accessToken(state){
      return state.accessToken
    },
    currentUser(state){
      return state.currentUser
    }
  },
  mutations: {
    setAtmWebOrigin (state,payload) {
      state.atmWebOrigin = payload
    },
    setAccessToken(state,payload){
      state.accessToken = payload
    },
    setCurrentUser(state,payload){
      state.currentUser = payload
    }
  },
  actions: {

  },
}
export default atmStoreModule